// src/pages/station_types/StationTypeList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import stationTypeService from '../../services/stationTypeService';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';

const StationTypeList = () => {
  const [stationTypes, setStationTypes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStationTypes = async () => {
      const response = await stationTypeService.getStationTypes();
      setStationTypes(response.data);
    };
    fetchStationTypes();
  }, []);

  const handleDelete = async (id) => {
    await stationTypeService.deleteStationType(id);
    setStationTypes(
      stationTypes.filter((stationType) => stationType.id !== id)
    );
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Station Types' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/station-types/new')}
          >
            Add Station Types
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Event ID</TableCell>
              <TableCell>Event Section ID</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {stationTypes.map((stationType) => (
              <TableRow key={stationType.id}>
                <TableCell>{stationType.type}</TableCell>
                <TableCell>{stationType.event_id}</TableCell>
                <TableCell>{stationType.event_section_id}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/station-types/edit/${stationType.id}`)
                    }
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton onClick={() => handleDelete(stationType.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default StationTypeList;
